import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import MobileNewsItem from "/components/Mobile/MobileNewsItem";
import DesktopNewsItem from "/components/Desktop/DesktopNewsItem";
import MobileFeatureCarousel from '/components/Mobile/MobileFeatureCarousel';
import DesktopFeatureCarousel from '/components/Desktop/DesktopFeatureCarousel';
import DesktopFeatureCarouselItem from '/components/Desktop/DesktopFeatureCarouselItem';
import Hidden from '@material-ui/core/Hidden';
import Grid from '@material-ui/core/Grid';
import ThereIsNoItem from '/components/thereIsNoItem';
import ReadAllLinkForTab from './ReadAllLinkForTab';

const styles = {
    root: {
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        overflow: 'hidden',
    },
};

class Articles extends React.Component {
    render(){
        const { brandArticles, carousel, mobileMaxNum, classes, btn, nextItemsMobile, nextItemsDesktop, isArticleTab, readAllClick, brandProfileName, authorArticles } = this.props;
        const isAuthorArticles = authorArticles ? authorArticles : false;
      
        return(
            <div>
                {carousel && carousel.length == 0 || brandArticles && brandArticles.length == 0 ? 
                     <ThereIsNoItem thereIsNoItem="There are no articles." />:   
                    <div>
                        <Hidden only={['md', 'lg', 'xl']}>
                            { isAuthorArticles ? null : carousel && carousel.length == 0 ? null : carousel && carousel.length == 1 ?  <DesktopFeatureCarouselItem carouselItem={carousel} /> : <MobileFeatureCarousel carouselItems={carousel} /> }
                            <div className={classes.root}>
                                <div className='mobileLayout' style={{marginTop: 15}}>
                                    {brandArticles.length > 0 && brandArticles.map((item, index) => {
                                    const mobileMaxNumber = mobileMaxNum ? index < mobileMaxNum : item
                                       return (
                                            mobileMaxNumber ?
                                            <React.Fragment key={index}> 
                                                    <MobileNewsItem item={item} />
                                                </React.Fragment>
                                            : null 
                                    )})}
                                    {isArticleTab && nextItemsMobile}
                                    {isArticleTab && btn}
                                    {!isArticleTab && <ReadAllLinkForTab tabIndex={1} readAllClick={readAllClick} color="#0A0A0A" readAll={`Read All Latest ${brandProfileName} Articles`} />}
                                    
                                </div>
                            </div>
                        </Hidden>
                        <Hidden smDown>
                            <div className={classes.root}>
                                <div className='layout'>
                                    <div style={{ display: 'block' }}>
                                        { isAuthorArticles ? null : carousel && carousel.length == 0 ? null : carousel && carousel.length == 1 ?  <DesktopFeatureCarouselItem carouselItem={carousel} /> : <DesktopFeatureCarousel carouselItems={carousel} /> }
                                    </div>
                                    <Grid container style={{marginTop: 15}}>
                                    {brandArticles.length > 0 && brandArticles.map((item, index) => (
                                        index < 8 ?
                                        <React.Fragment key={index}>
                                            <Grid item xs={3}>
                                                <DesktopNewsItem item={item}  />
                                            </Grid>
                                        </React.Fragment>
                                        : null
                                    ))}  
                                    
                                        </Grid>
                                    {isArticleTab && nextItemsDesktop}
                                    {isArticleTab && btn}
                                    {!isArticleTab && <ReadAllLinkForTab tabIndex={1} readAllClick={readAllClick} color="#0A0A0A" readAll={`Read All Latest ${brandProfileName} Articles`} />}
                                    </div>
                                </div>
                            
                        </Hidden>
                    </div>
                }
            </div>
        )
    }
}

Articles.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Articles);
